import { render, staticRenderFns } from "./BranceOther.vue?vue&type=template&id=410f0890"
import script from "./BranceOther.vue?vue&type=script&lang=js"
export * from "./BranceOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports